module.exports = __webpack_public_path__ + "static/media/2021_180k.a2f8dcaf.gpx";